module.exports = __webpack_public_path__ + "static/media/University of Illinois at Chicago Logo.d84f9e95.png";